import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';

import Login from './Login';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: 100,
    paddingBottom: 100,
    [theme.breakpoints.down('md')]: {
      paddingTop: 60,
      paddingBottom: 60
    }
  },
  technologyIcon: {
    height: 40,
    margin: theme.spacing(1)
  },
  image: {
    perspectiveOrigin: 'left center',
    transformStyle: 'preserve-3d',
    perspective: 1500,
    '& > img': {
      maxWidth: '90%',
      height: 'auto',
      transform: 'rotateY(-35deg) rotateX(15deg)',
      backfaceVisibility: 'hidden',
      boxShadow: theme.shadows[16]
    }
  },
  shape: {
    position: 'absolute',
    top: 0,
    left: 0,
    '& > img': {
      maxWidth: '90%',
      height: 'auto'
    }
  }
}));

const Hero = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
            md={5}
          >
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height="100%"
            >
              <Typography
                variant="overline"
                color="secondary"
              >
                Be Better Advertising
              </Typography>
              <Typography
                variant="h1"
                color="textPrimary"
              >
                Nova Application
              </Typography>
              <Box mt={3}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                >
                  A Be Better Advertising monitoring and management system for affiliate applications. A convenient way of submitting, scheduling, 
                  and optimizing advertorial campaigns of different traffic sources.
                </Typography>
              </Box>
              <Box mt={3}>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid item>
                    <Typography
                      variant="h1"
                      color="secondary"
                    >
                      7+
                    </Typography>
                    <Typography
                      variant="overline"
                      color="textSecondary"
                    >
                      Traffic Sources
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="h1"
                      color="secondary"
                    >
                      4+
                    </Typography>
                    <Typography
                      variant="overline"
                      color="textSecondary"
                    >
                      Affiliate Clients
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="h1"
                      color="secondary"
                    >
                      100+
                    </Typography>
                    <Typography
                      variant="overline"
                      color="textSecondary"
                    >
                      Campaigns
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={3}>
                <img
                  alt="RevContent"
                  className={classes.technologyIcon}
                  src="/static/images/logos/revcontent-logo.png"
                />
                <img
                  alt="MGID"
                  className={classes.technologyIcon}
                  src="/static/images/logos/mgid-logo-big.png"
                />
                <img
                  alt="Jubna"
                  className={classes.technologyIcon}
                  src="/static/images/logos/jubna-logo-sq.png"
                />
                <img
                  alt="RTX"
                  className={classes.technologyIcon}
                  src="/static/images/logos/rtx-logo-sq.jpg"
                />
                <img
                  alt="EngageYa"
                  className={classes.technologyIcon}
                  src="/static/images/logos/engageya-logo-sq.png"
                />
                <img
                  alt="SelfAdvertiser"
                  className={classes.technologyIcon}
                  src="/static/images/logos/selfadvertiser-logo.png"
                />
                <img
                  alt="Ad-Maven"
                  className={classes.technologyIcon}
                  src="/static/images/logos/admaven-logo-sq.png"
                />
              </Box>
              <Box mt={3}>
                <img
                  alt="Adsu"
                  className={classes.technologyIcon}
                  src="/static/images/logos/adsu-logo.png"
                />
                <img
                  alt="ClickDealer"
                  className={classes.technologyIcon}
                  src="/static/images/logos/clickdealer-logo-sq.png"
                />
                <img
                  alt="Affiliati"
                  className={classes.technologyIcon}
                  src="/static/images/logos/affiliati-logo.png"
                />
                <img
                  alt="Zodiac"
                  className={classes.technologyIcon}
                  src="/static/images/logos/zodiac-logo.png"
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={7}
          >
            <Box position="relative">
              <div className={classes.shape}>
                <img
                  alt="Shapes"
                  src="/static/home/shapes.svg"
                />
              </div>
              <div className={classes.image}>
                <Login />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

Hero.propTypes = {
  className: PropTypes.string
};

export default Hero;
